export default {
  moistureContent: {
    BS_EN_1097_5: { rev2008: '110486' },
  },
  losAngelesValue: {
    BS_EN_1097_2_Clause_5: { rev2020: '110495' },
  },
  moistureConditionValue: {
    BS_EN_13286_46: { rev2003: '110510' },
  },
  particleDensity: {
    BS_EN_1097_6_Clause_7: { rev2022: '110513' },
  },
  psdSieveAnalysis: {
    BS_EN_933_1: { Rev2012: '110963' },
  },
  wash: {
    BS_EN_933_1: { Rev2012: '110965' },
  },
};
